// --- Google Analytics 4 (GA4) ---------------------------------------------
// Paste your GA4 Measurement ID below (it looks like "G-XXXXXXXXXX") to turn
// analytics ON. Leave it empty to keep analytics disabled.
//
// Where to get the ID:
//   Firebase Console → your project → Analytics (enable Google Analytics),
//   or analytics.google.com → Admin → Data Streams → your web stream.
//
// What GA4 then records automatically: visits, unique visitors, which pages
// they view, how long they stay (engagement time), where they're from, and
// what device they use — viewable in the GA / Firebase dashboard.
export const GA_MEASUREMENT_ID = "G-P865PSWZ5K";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

let started = false;

/** Loads the GA4 script once. No-op when no Measurement ID is set. */
export function initAnalytics(): void {
  if (started || !GA_MEASUREMENT_ID) return;
  started = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  // gtag.js requires the actual `arguments` object pushed to dataLayer — a
  // plain array is silently ignored, so use the canonical stub here.
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  // Single-page app: send page_view manually on each route change instead.
  window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
}

/** Records a page view for the given path. No-op when analytics is disabled. */
export function trackPageview(path: string): void {
  if (!GA_MEASUREMENT_ID || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}
